import { Component, OnInit } from '@angular/core';
import { CalendarioEventi } from 'src/app/models/calendarioeventi';
import { EventsCalendarService } from 'src/app/core/services/events-calendar/events-calendar.service';
import { EventsCalendarStore } from 'src/app/core/services/events-calendar/events-calendar.store';

@Component({
  selector: 'app-events-calendar',
  templateUrl: './events-calendar.component.html',
  styleUrls: []
})
export class EventsCalendarComponent implements OnInit {

  today = new Date();
  selectedYear = new Date().getFullYear();
  selectedMonth = new Date().getMonth();
  firstDay = (new Date(this.selectedYear, this.selectedMonth)).getDay();
  daysInMonth = 32 - new Date(this.selectedYear, this.selectedMonth, 32).getDate();
  numberOfWeeks = Math.ceil(this.daysInMonth / 7);
  eventsPerDay = [];

  months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  monthAndYear = this.months[this.selectedMonth] + ' ' + this.selectedYear;

  constructor(private service: EventsCalendarService,
              private store: EventsCalendarStore) { }

  ngOnInit(): void {
   // this.getRecords(new Date());
  }

  getRecords(date: Date) {
    this.service.get(date)
      .subscribe(
        () => this.getPrivateRecords(date)
      );
  }

  getPrivateRecords(date: Date) {
    this.service.getPrivate(date)
    .subscribe(
      () => {
        for (let i = 0; i < this.daysInMonth; ++i) {
          const filtered = this.store.records.filter((item: CalendarioEventi) => {
            return (new Date(item.dataevento).getDate() === i + 1);
          });
          this.eventsPerDay[i] = filtered.length;
         }
        this.showCalendar(this.selectedMonth, this.selectedYear);
      }
    )
  }

  showCalendar(month: number, year: number) {

    this.firstDay = (new Date(this.selectedYear, this.selectedMonth)).getDay();
    this.monthAndYear = this.months[month] + ' ' + year;

    const tbl = document.getElementById('calendar-body'); // body of the calendar

    // // clearing all previous cells
    tbl.innerHTML = '';

    // creating all cells
    let date = 1;

    for (let i = 0; i < 6; i++) {
      // creates a table row
      const row = document.createElement('tr');

      // creating individual cells, filing them up with data.
      for (let j = 0; j < 7; j++) {
        if (i === 0 && j < this.firstDay) {
          const cell = document.createElement('td');
          const cellText = document.createTextNode('');
          cell.appendChild(cellText);
          row.appendChild(cell);
        } else if (date > this.daysInMonth) {
          break;
        } else {
          const cell = document.createElement('td');
          const cellText = document.createTextNode(date.toString());

          const isToday = date === this.today.getDate() && year === this.today.getFullYear() && month === this.today.getMonth();

          if (isToday) {
            cell.classList.add('active');
          }

          cell.appendChild(cellText);

          if (this.eventsPerDay[date] > 0) {
            const link = document.createElement('a');
            link.style.float = 'right';
            const pin = document.createElement('i');
            pin.className = 'fa fa-thumb-tack';
            (isToday) ? pin.style.color = 'blue' : pin.style.color = 'red';
            link.append(pin);
            cell.appendChild(link);
          }
          row.appendChild(cell);
          date++;
        }
      }
      tbl.appendChild(row); // appending each row into calendar body.
    }
  }

  next() {
    this.selectedYear = (this.selectedMonth === 11) ? this.selectedYear + 1 : this.selectedYear;
    this.selectedMonth = (this.selectedMonth + 1) % 12;
    this.getRecords(new Date(this.selectedYear, this.selectedMonth));
    this.showCalendar(this.selectedMonth, this.selectedYear);
  }

  previous() {
    this.selectedYear = (this.selectedMonth === 0) ? this.selectedYear - 1 : this.selectedYear;
    this.selectedMonth = (this.selectedMonth === 0) ? 11 : this.selectedMonth - 1;
    this.getRecords(new Date(this.selectedYear, this.selectedMonth));
    this.showCalendar(this.selectedMonth, this.selectedYear);
  }

  changeYear(year: number) {
    this.selectedYear = year;
    this.getRecords(new Date(this.selectedYear, this.selectedMonth));
    this.showCalendar(this.selectedMonth, this.selectedYear);
  }

  changeMonth(month: string) {
    this.selectedMonth = this.months.indexOf(month);
    this.getRecords(new Date(this.selectedYear, this.selectedMonth));
    this.showCalendar(this.selectedMonth, this.selectedYear);
  }

  createRange(num: number) {
    const arr = [];
    for (let i = 1; i <= num; ++i) {
      arr.push(i);
    }
    return arr;
  }

}
